import { CssBaseline, ThemeProvider } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";
import { SpecialRightsProvider } from "../../../context/SpecialRightsContext";
import { ColorModeContext, useMode } from "../../../theme/theme";

interface Props {
  children: React.ReactNode;
}

const AppProviders = ({ children }: Props) => {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <HelmetProvider>
          <SpecialRightsProvider>{children}</SpecialRightsProvider>
        </HelmetProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default AppProviders;
